var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_vm._v("Credit Card Returns")]),_c('div',{staticClass:"body-2"},[_vm._v("Processed credit card returns. Some credit card returns may only mean to return overcharged credit cards.")]),_c('List',{staticClass:"my-8",attrs:{"range":_vm.range}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }